import App from "#puf/App.tsx";
import { AUTOSAVE_KEY } from "#puf/constants.ts";
import { store } from "#puf/store/index.ts";
import { installStoreInvariantGate } from "#puf/store/invariant.ts";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "#puf/styles.css";

const exposeStoreForTests = import.meta.env.DEV || hasE2EFlag();

if (exposeStoreForTests) {
  // Expose the store globally for Playwright assertions and console debugging.
  // Old Zustand `useStore` was exposed under the same key — callers now use
  // `store.getSnapshot().context.x` instead of `store.getState().x`.
  window.__pufStore = store;
}

if (import.meta.env.DEV) {
  installStoreInvariantGate();
}

// One-shot cleanup of the pre-migration autosave key. The new persist layer writes to
// `localStorage["pixelpuf:store"]`; the legacy `pxpf:autosave` (gzip+base64 .pxpf payload)
// is orphaned. Safe to remove on every load — it's idempotent.
try {
  window.localStorage.removeItem(AUTOSAVE_KEY);
} catch {
  // localStorage may be unavailable (privacy mode); ignore.
}

const root = document.getElementById("root");
if (!root) throw new Error("#root missing");
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

function hasE2EFlag(): boolean {
  try {
    return new URL(window.location.href).searchParams.get("__e2e") === "1";
  } catch {
    return false;
  }
}
